import React from 'react';
import {Box, Tab, TabIndicator, TabList, Tabs} from '@chakra-ui/react';
import {useLocation} from 'react-router-dom';
import {Link} from 'react-router-dom';
import {IntentTabs} from './IntentTabs';

export const IntentModelTabs = () => {
  const location = useLocation();
  const tabIndex = IntentTabs.findIndex((tab) =>
    location.pathname.endsWith(tab.path)
  );

  return (
    <Tabs index={tabIndex} variant="unstyled">
      <Box position="relative">
        <TabList color="kgray.300" gap="2">
          {IntentTabs.map(({path, label}) => (
            <Tab
              as={Link}
              to={path}
              key={path}
              px="2"
              whiteSpace="nowrap"
              _focus={{boxShadow: 'unset'}}
              _hover={{color: 'kgray.400'}}
              _selected={{color: 'kgray.400'}}
            >
              {label}
            </Tab>
          ))}
        </TabList>
        <TabIndicator height="2px" bg="kblue.400" borderRadius="1px" />
      </Box>
    </Tabs>
  );
};
